export enum TimeLevelEnum {
    Daily = 1,
    Weekly = 2,
    Monthly = 3,
    Quarterly = 4,
    Yearly = 5,
    All = 6
}

export default class TimeLevel {

    public static GetByValue(value: number) {
        switch (value) {
            case 1:
                return TimeLevelEnum.Daily;
            case 2:
                return TimeLevelEnum.Weekly;
            case 3:
                return TimeLevelEnum.Monthly;
            case 4:
                return TimeLevelEnum.Quarterly;
            case 5:
                return TimeLevelEnum.Yearly;
            default:
                return undefined;
        }
    }

    static GetFromText(text: string) {
        switch (text.toLowerCase()) {
            case "daily":
                return TimeLevelEnum.Daily;
            case "weekly":
                return TimeLevelEnum.Weekly;
            case "monthly":
                return TimeLevelEnum.Monthly;
            case "quarterly":
                return TimeLevelEnum.Quarterly;
            case "yearly":
                return TimeLevelEnum.Yearly;
            case "all":
                return TimeLevelEnum.Daily;
            default:
                return TimeLevelEnum.Daily;
        }
    }

    static toString(timelevel: TimeLevelEnum) {
        switch(timelevel) {
            case TimeLevelEnum.Daily:
                return 'Daily';
            case TimeLevelEnum.Weekly:
                return 'Weekly';
            case TimeLevelEnum.Monthly:
                return 'Monthly';
            case TimeLevelEnum.Quarterly:
                return 'Quarterly';
            case TimeLevelEnum.Yearly:
                return 'Yearly';
            case TimeLevelEnum.All:
                return 'All';
        }
    }

}